// листинг в каталоге

import { ref , reactive , nextTick } from 'vue';
import { createApp , watch } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import { useContextStore } from '../../../../assets/site/js/contextStore.js'

function initLkPersonalPage(){

    const el = document.querySelector( '#lk-personal' );

    if( el ){
        createApp(
            {
                setup(){

                    const contextStore = useContextStore();
                    const data = reactive( context ?? {} );

                    const personal = reactive(
                        {
                            error : null,
                            value : {
                                name : {
                                    value : contextStore.getUser()?.name ,
                                    error : null
                                } ,
                                email : {
                                    value : contextStore.getUser()?.email ,
                                    error : null
                                } ,
                                phone : {
                                    value : contextStore.getUser()?.phone ,
                                    error : null
                                } ,
                                sex : {
                                    value : contextStore.getUser()?.sex ,
                                    error : null
                                }
                            }
                        }
                    );

                    function  applyValue( value ){
                        let temp = {};
                        for( let i in personal.value ){
                            temp[ i ] = value[ i ] ?? { value : null , error : null };
                        }
                        return temp;
                    }

                    async function save(){

                        try{
                            let response = await fetch(
                                '/api/lk/personal' ,
                                {
                                    method : 'POST' ,
                                    headers : data?.header ,
                                    body : JSON.stringify(
                                        {
                                            request : personal.value
                                        }
                                    )
                                }
                            );

                            let answer = await response.json();

                            personal.error = answer?.error;
                            personal.value = applyValue( answer?.value );

                        }catch( e ){
                            console.warn( e.name + ":" + e.message );
                        }

                    }

                    return {
                        contextStore ,
                        personal ,
                        save
                    }
                }
            }
        )
            .use( createPinia() )
            .mount( el )
    }


}

document.addEventListener( "DOMContentLoaded" , initLkPersonalPage );
